export * from './get-staff-member-photo';
